import { render, staticRenderFns } from "./Note.vue?vue&type=template&id=5819ab72"
var script = {}
import style0 from "./Note.vue?vue&type=style&index=0&id=5819ab72&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports